import { render, staticRenderFns } from "./maisoku.vue?vue&type=template&id=591a6d47&"
import script from "./maisoku.vue?vue&type=script&lang=js&"
export * from "./maisoku.vue?vue&type=script&lang=js&"
import style0 from "./maisoku.vue?vue&type=style&index=0&id=591a6d47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheHeaderMaisoku: require('/codebuild/output/src2191123635/src/frontend/src/components/TheHeaderMaisoku.vue').default,TheFooter: require('/codebuild/output/src2191123635/src/frontend/src/components/TheFooter.vue').default})
